import React from 'react';
import { Link } from 'react-router-dom';
import { Create, SimpleForm, required, TextInput, email, SelectInput, Toolbar,
        SaveButton, Edit } from 'react-admin';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { Title } from 'react-admin';
import { CleanChangePassword } from './CleanChangePassword'
import { LogJsonAfterForm } from './LogJsonAfterForm'
import queryString from 'query-string';

import PKSaveButton from './PKSaveButton';


const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: 'none',
  },
}));

export const RegisterList = (props) => {
    const classes = useStyles();
    return (
      <Card>
        <Title title="Welcome!" />
        <CardContent>
        <h1>Substitute Teachers Ireland</h1>
        <Card>
        <CardContent>
        <h6>Congratulations!</h6>
        <h4 style={{textDecoration: "underline"}}>Administrators - a stich in time saves nine</h4>
        <p>You've discovered the fastest and lowest cost way to find and hire qualified substitute teachers in Ireland.</p>
        <p>SIGN UP NOW FOR 3 MONTHS FREE!</p>
        <p>.. and take your first step towards securing your teaching resources for the future.
        Every subscription is underwritten by our money-back gaurantee if you are unsatisfied. Think how amazing it will be to never have to worry about wasted time and empty classes again.</p>
        <h4 style={{textDecoration: "underline"}}>Teachers - say yes to more work</h4>
        <p>You've discovered the best way to get local work as a substitute teacher. Restrict your job offers by location!</p>
        <p>ALWAYS FREE!</p>
        </CardContent>
        </Card>
        <br />
        <Link to={{pathname: "/register/create"}}  className={classes.button}>
          <Button variant="contained" color="primary" >
            sign up now!
          </Button>
        </Link>
        <Link to={{pathname: "/login"}} >
          <Button variant="contained" color="danger" className={classes.button}>
            Login
          </Button>
        </Link>
        <Link to={{pathname: "/register/create"}}  className={classes.button}>
          <Button variant="contained" color="danger" >
            resend registration verification
          </Button>
        </Link>
        </CardContent>
    </Card>
  )
};

export const RegisterList2 = (props) => {
    const classes = useStyles();
    return (
      <Card>
        <Title title="Welcome!" />
        <CardContent>
        <p>Select 'Login' below if you are already registered, otherwise 'Register'.</p>
        <p>Be sure to register as an Administrator if you want to search for sub-teachers.</p>
        <p>Registration is always free for teachers.</p>
        <Link to={{pathname: "/login"}} >
          <Button variant="contained" color="primary" className={classes.button}>
            Login
          </Button>
        </Link>
        <Link to={{pathname: "/register/create"}}  className={classes.button}>
          <Button variant="contained" color="primary" >
            Register
          </Button>
        </Link>
        </CardContent>
    </Card>
  )
};
const email_and_required = [required('required'), email('not a valid email address')]

const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/
const password_validation = (value, allValues) => {
  const re_value = re.test(value) ? true : false
  if(!re_value) {
    return "Password must contain one each of 0-9, a-z and A-Z"
  }
}

const passwords_match = (value, allValues) => {
  if(allValues.password !== allValues.password_confirm) {
    return "Passwords don't match"
  }
}

const password_validations = [password_validation, passwords_match]


const RegisterCreateToolbar = props => {
    const classes = useStyles();
    const link_path = "/resend_registration/create"
    return <Toolbar {...props} >
        <SaveButton redirect="/login?previous=registration" label="Register"/>
        <Link to={{pathname: link_path}} >
          <Button variant="contained" color="danger" className={classes.button}>
            Resend Registration Verification
          </Button>
        </Link>
    </Toolbar>
};


export const RegisterCreate = (props) => (
    <Create title={"Register"}  {...props}>
        <SimpleForm redirect="/login?previous=registration" toolbar={<RegisterCreateToolbar />}>
            <TextInput
              className="md-cell md-cell--top"
              label="Email"
              name="id"
              validate={email_and_required}
              source="id" />
            <TextInput
              className="md-cell md-cell--top"
              label="First Name"
              name="firstname"
              validate={required('Required')}
              source="firstname" />
            <TextInput
              className="md-cell md-cell--top"
              label="Last Name"
              name="lastname"
              validate={required('Required')}
              source="lastname" />
            <TextInput
              className="md-cell md-cell--top"
              label="Password"
              name="password"
              validate={password_validations}
              source="password"
              type="password"/>
            <TextInput
              className="md-cell md-cell--top"
              label="Confirm Password"
              name="password_confirm"
              validate={password_validations}
              source="password_confirm"
              type="password"/>
            <SelectInput
              label="Role Teacher/Administrator"
              source="pkrole"
              validate={required('Required')}
              choices={[
                { id: 'teacher', name: 'Teacher' },
                { id: 'admin', name: 'School Administrator' }
            ]} />
        </SimpleForm>
    </Create>
);


const PostCreateToolbar = props => {
    const classes = useStyles();
    const link_path = "/password_change/"+props.record.id+"/edit"
    return <Toolbar {...props} >
        <SaveButton redirect="edit"/>
        <Link to={{pathname: link_path}} >
          <Button variant="contained" color="primary" className={classes.button}>
            Change Password
          </Button>
        </Link>
    </Toolbar>
};


export const UserProfileEdit = (props) => (
    <Edit title={"User Profile"} {...props}>
        <SimpleForm toolbar={<PostCreateToolbar />} >
            <TextInput
              disabled="true"
              className="md-cell md-cell--top"
              label="Email"
              name="id"
              validate={email_and_required}
              source="id" />
            <TextInput
              className="md-cell md-cell--top"
              label="First Name"
              name="firstname"
              validate={required('Required')}
              source="firstname" />
            <TextInput
              className="md-cell md-cell--top"
              label="Last Name"
              name="lastname"
              validate={required('Required')}
              source="lastname" />
        </SimpleForm>
    </Edit>
);

const change_passwords_match = (value, allValues) => {
  if(allValues.new_password !== allValues.new_password_confirm) {
    return "Passwords don't match"
  }
}

const change_password_validations = [password_validation, change_passwords_match]

const ChangePasswordToolbar = props => {
    const link_path = "/user_profile/"+props.record.id+"/edit"
    return <Toolbar {...props} >

        <CleanChangePassword redirect={link_path}/>
    </Toolbar>
};

export const ChangePasswordEdit = (props) => (
    <Edit title={"User Profile"} {...props}>
        <SimpleForm toolbar={<ChangePasswordToolbar />}>
            <TextInput
              className="md-cell md-cell--top"
              label="Current Password"
              name="password"
              validate={required('Required')}
              source="password"
              type="password"/>
            <TextInput
              className="md-cell md-cell--top"
              label="New Password"
              name="new_password"
              validate={change_password_validations}
              source="new_password"
              type="password"/>
            <TextInput
              className="md-cell md-cell--top"
              label="Confirm New Password"
              name="new_password_confirm"
              validate={change_password_validations}
              source="new_password_confirm"
              type="password"/>
        </SimpleForm>
    </Edit>
);


const ResendToolbar = props => {
    return <Toolbar {...props} >
        <SaveButton redirect="/login?previous=registration" label="Resend Registration Email"/>
    </Toolbar>
};
export const ResendRegistrationVerification = (props) => (
    <Create title={"Resend Registration Verification"}  {...props}>
        <SimpleForm redirect="/login?previous=registration" toolbar={<ResendToolbar />}>
            <TextInput
              className="md-cell md-cell--top"
              label="Email"
              name="id"
              validate={email_and_required}
              source="id" />
            <TextInput
              className="md-cell md-cell--top"
              label="Password"
              name="password"
              validate={required('Required')}
              source="password"
              type="password"/>
        </SimpleForm>
    </Create>
);



const VerifyUserToolbar = props => {
    return <Toolbar {...props} >
        <LogJsonAfterForm redirect="/" label="Enter login details to verify user"/>
    </Toolbar>
};
export const VerifyUser = (props) => {
    const query_params = queryString.parse(props.location.search)
    return <Create title={"Verify User"} {...props}>
        <SimpleForm toolbar={<VerifyUserToolbar />}>
            <TextInput
              className="md-cell md-cell--top"
              label="Email"
              name="id"
              validate={email_and_required}
              source="id" />
            <TextInput
              className="md-cell md-cell--top"
              label="Password"
              name="password"
              validate={required('Required')}
              source="password"
              type="password"/>
            <TextInput
              className="md-cell md-cell--top"
              label="Token"
              name="registrationtoken"
              validate={required('Required')}
              source="registrationtoken"
              defaultValue={query_params.token}/>
        </SimpleForm>
    </Create>
};


const RequestPasswordResetToolbar = props => {

    return <Toolbar {...props} >
        <PKSaveButton  redirect="/login?previous=request_password_reset" label="pk.request_password_reset"/>
    </Toolbar>
};


export const RequestPasswordReset = (props) => (
    <Create title="pk.request_password_reset"  {...props} >
        <SimpleForm  toolbar={<RequestPasswordResetToolbar/>}>
            <TextInput
              className="md-cell md-cell--top"
              label="Email"
              name="users_id"
              validate={email_and_required}
              source="users_id" />
        </SimpleForm>
    </Create>
);


export const ResetPassword = (props) => {
  const query_params = queryString.parse(props.location.search)
  console.log(query_params)
  return <Create title={"pk.reset_password"} {...props}>
        <SimpleForm>
            <TextInput
              className="md-cell md-cell--top"
              label="Email"
              name="users_id"
              validate={email_and_required}
              source="users_id" />
            <TextInput
              className="md-cell md-cell--top"
              label="New Password"
              name="new_password"
              validate={change_password_validations}
              source="new_password"
              type="password"/>
            <TextInput
              className="md-cell md-cell--top"
              label="Confirm New Password"
              name="new_password_confirm"
              validate={change_password_validations}
              source="new_password_confirm"
              type="password"/>
            <TextInput
                name="token"
                label="Hidden Token field"
                hidden={true}
                defaultValue={query_params.token}
                source="token"
            />
        </SimpleForm>
    </Create>
  }
